import { render, staticRenderFns } from "./WordImportPage.vue?vue&type=template&id=c53089fe&scoped=true&"
import script from "./WordImportPage.vue?vue&type=script&lang=js&"
export * from "./WordImportPage.vue?vue&type=script&lang=js&"
import style0 from "./WordImportPage.vue?vue&type=style&index=0&id=c53089fe&prod&lang=scss&scoped=true&"
import style1 from "./WordImportPage.vue?vue&type=style&index=1&id=c53089fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53089fe",
  null
  
)

export default component.exports